import { ShieldCheck } from "lucide-react";

/**
 * Last-resort branded placeholder — used only when a record has no verified photo, or its photo
 * fails to load. Never a fake photo: a calm Shingare-branded tile with the item's name, so an empty
 * frame is never shown. Every use is tracked in the image audit's "fallback" report.
 */
export default function ImageFallback({ label = "", className = "", dark = false, "data-testid": testId = "image-fallback" }) {
  return (
    <div
      role="img"
      aria-label={label ? `${label} — image coming soon` : "Image coming soon"}
      data-testid={testId}
      className={`relative flex flex-col items-center justify-center gap-2 overflow-hidden text-center ${className}`}
      style={{ background: dark ? "linear-gradient(135deg,#0B2348,#071B3A)" : "linear-gradient(135deg,#F7F9FC,#E8EEF7)" }}
    >
      <div
        aria-hidden="true"
        className="absolute inset-0 opacity-[0.5]"
        style={{ backgroundImage: `linear-gradient(${dark ? "rgba(255,255,255,.05)" : "rgba(11,35,72,.05)"} 1px,transparent 1px),linear-gradient(90deg,${dark ? "rgba(255,255,255,.05)" : "rgba(11,35,72,.05)"} 1px,transparent 1px)`, backgroundSize: "28px 28px" }}
      />
      <ShieldCheck className={`relative w-8 h-8 ${dark ? "text-white/40" : "text-[#1769FF]/40"}`} strokeWidth={1.5} />
      {label && <span className={`relative max-w-[80%] text-[11px] font-medium leading-snug line-clamp-2 ${dark ? "text-white/50" : "text-[#667085]"}`}>{label}</span>}
    </div>
  );
}
